{
    "FormEngineConditionWfl": {
        "title": "Condition",
        "description": "Restrict execution to meeting of a condition"
    },
    "mask": {
        "FormEngineConditionWfl": {
            "groupTitle": "Condition"
        }
    }
}